var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIconTimelive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.443 151.952C165.583 172.448 144.357 186.949 120.08 192.506C95.8027 198.063 70.2989 194.258 48.7556 181.864C27.2124 169.471 11.2476 149.421 4.10844 125.791C-3.0307 102.162 -0.808027 76.7284 10.3244 54.6634L36.6271 67.6644C28.8344 83.1099 27.2785 100.913 32.2759 117.454C37.2733 133.995 48.4487 148.03 63.5289 156.705C78.6092 165.38 96.4619 168.044 113.456 164.154C130.45 160.265 145.308 150.114 155.01 135.766L179.443 151.952Z",
    fill: "url(#paint0_linear_3081_62775)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3458 10.4853C67.8943 3.58699 82.8556 -0.00431393 98.0273 5.04696e-06C113.199 0.00432402 128.158 3.60414 141.703 10.5102L128.592 36.7571C119.111 31.9229 108.639 29.403 98.0191 29.4C87.3989 29.397 76.926 31.9109 67.4421 36.7397L54.3458 10.4853Z",
    fill: "url(#paint1_linear_3081_62775)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3948 44.4684V86.044C99.3948 88.15 98.172 89.8484 96.6095 89.8484C95.047 89.8484 93.8242 88.15 93.8242 86.044V44.4684C93.8242 42.3624 95.047 40.6641 96.6095 40.6641C98.172 40.6641 99.3948 42.3624 99.3948 44.4684Z",
    fill: "#192830"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.346 109.467H114.746C113.251 109.467 112.164 108.04 112.164 106.342C112.164 104.643 113.319 103.217 114.746 103.217H143.346C144.84 103.217 145.927 104.643 145.927 106.342C145.859 108.108 144.772 109.467 143.346 109.467Z",
    fill: "#192830"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9573 117.817C103.291 117.817 108.425 112.683 108.425 106.349C108.425 100.015 103.291 94.8809 96.9573 94.8809C90.6237 94.8809 85.4893 100.015 85.4893 106.349C85.4893 112.683 90.6237 117.817 96.9573 117.817Z",
    fill: "url(#paint2_linear_3081_62775)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3081_62775",
    x1: -7.29787,
    y1: 99.043,
    x2: 176.191,
    y2: 99.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A83B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0682,
    stopColor: "#9F3B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1813,
    stopColor: "#85399C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3245,
    stopColor: "#5C37AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3941,
    stopColor: "#4636B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#4139BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6082,
    stopColor: "#3143C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7397,
    stopColor: "#1852D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#0061DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3081_62775",
    x1: 15.6021,
    y1: 97.9855,
    x2: 140.763,
    y2: 97.9855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00495897,
    stopColor: "#DD1568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1944,
    stopColor: "#DE1868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3487,
    stopColor: "#E02266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4905,
    stopColor: "#E33363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#E84B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7542,
    stopColor: "#EE6A5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8777,
    stopColor: "#F69056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9978,
    stopColor: "#FFBC4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3081_62775",
    x1: 85.4548,
    y1: 106.329,
    x2: 108.495,
    y2: 106.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A83B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0682,
    stopColor: "#9F3B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1813,
    stopColor: "#85399C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3245,
    stopColor: "#5C37AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3941,
    stopColor: "#4636B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#4139BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6082,
    stopColor: "#3143C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7397,
    stopColor: "#1852D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#0061DC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconTimelive);
export default __webpack_public_path__ + "static/media/logo-Icon-timelive.2e171a346bfa88929b90503db24986e5.svg";
export { ForwardRef as ReactComponent };